module.exports = __webpack_public_path__ + "img/export.c5fa46ed.svg";